import React from 'react';

const sizeClasses = {
  small: 'size-4 border-2',
  sm: 'size-4 border-2',
  medium: 'size-6 border-[2.5px]',
  md: 'size-6 border-[2.5px]',
  large: 'size-10 border-[3px]',
  lg: 'size-10 border-[3px]',
};

/**
 * A round spinner. `color` is the moving arc (brand orange by default).
 */
const LoadingSpinner = ({ size = 'medium', color = '#e08a08' }) => {
  // Some callers pass a pixel number; treat it as a size in px.
  const isPixelSize = typeof size === 'number';
  const pixelStyle = isPixelSize ? { width: size, height: size, borderWidth: Math.max(2, Math.round(size / 10)) } : {};

  return (
    <div className="flex items-center justify-center" role="status" aria-label="Loading">
      <div
        className={`${isPixelSize ? '' : sizeClasses[size] || sizeClasses.medium} animate-spin rounded-full border-ui-line`}
        style={{ ...pixelStyle, borderTopColor: color }}
      />
    </div>
  );
};

export default LoadingSpinner;
